( ( $ ) => {
	if ( $( '.wp-block-table.is-style-stack' ).length > 0 ) {
		function fixHeadingsInTableStack() {
			if ( $( window ).width() < 992 ) {
				$( '.wp-block-table.is-style-stack' ).each( function() {
					const table = $( this );
					const trArray = table.find( 'tbody tr' );
					const thArray = table.find( 'thead tr th' );
					trArray.each( function() {
						const tdArray = $( this ).find( 'td' );
						tdArray.before( function( index ) {
							const thText = thArray.eq( index ).text();
							return '<th class="table-stack__heading">' + thText + ':</th>'
						} );
					} );
				} );
			} else {
				$( '.table-stack__heading' ).remove();
			}
		}
		fixHeadingsInTableStack();
		$( window ).resize( function() {
			fixHeadingsInTableStack();
		} );
	}
})(jQuery)
